module.exports = __webpack_public_path__ + "img/Vermutete_Gefahr_durch_Radioaktivität.d4064b9b.svg";